<script>
export default {
	name: "RenderNode",
	props: {
		render: {
			type: Function,
			required: true
		},
		row: {
			type: Object,
			required: true
		},
		index: {
			type: Number,
			required: true
		},
		rowKey: {
			type: String,
			required: true
		}
	},
	render(h) {
		return this.render(h, { row: this.row, index: this.index, key: this.rowKey });
	}
};
</script>
